import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import {Observable} from 'rxjs';

@Injectable()
export class ObjectsService {

  constructor(private httpClient: HttpClient) {
  }


  public getList(): Observable<any> {
    return this.httpClient.get('/db/object');
  }

  public getListByRubric(rubricId): Observable<any> {
    return this.httpClient.get(`/db/object/child/objrubric/${rubricId}`);
  }

  public getControllers(id): Observable<any> {
    return this.httpClient.get(`/db/controller/child/object/${id}`);
  }

  public getDevices(id): Observable<any> {
    return this.httpClient.get(`/db/object/${id}/unit`);
  }

  public getParams(objectId): Observable<any> | Observable<any[]> {
    /*console.log('getParams(/db/object/id/params');*/
    /*return forkJoin([this.httpClient.get(`/db/object/${objectId}/params`),this.httpClient.get(`/search/params?oid=${objectId}`)]);*/
    return this.httpClient.get(`/search/params?oid=${objectId}`);
  }
}
